import axios from "axios";
import * as helper from "../utils/helper";

export default {
    baseUrl() {
        return helper.server.baseURL;
    },
    apiUrl() {
        return helper.server.baseApiURL;
    },
    adminApiUrl() {
        return helper.server.adminURL;
    },

    handleAuthFailure() {
        const store = require('../store').default;
        store.commit('logOutUser');
        if (typeof window === 'undefined') {
            return;
        }
        const loginPath = `${process.env.BASE_URL || '/admin/'}login`.replace(/([^:]\/)\/+/g, '$1');
        if (window.location.pathname.indexOf(loginPath) === -1) {
            window.location.assign(loginPath);
        }
    },

    async post(url, data = {}, headers = {}) {
        return await axios.post(url, data, {headers: headers})
    },

    async refreshToken() {
        if (!localStorage.getItem('admin_user')) {
            this.handleAuthFailure();
            throw new Error('Admin session not found');
        }

        const jwt = localStorage.getItem('jwt');
        if (!jwt) {
            this.handleAuthFailure();
            throw new Error('JWT not found');
        }

        try {
            const response = await axios.get(
                `${this.apiUrl()}/admin/refresh_token`,
                { headers: this.getAuthHeader() },
            );
            const access_token = response.data?.access_token || null;
            if (!access_token) {
                this.handleAuthFailure();
                throw new Error('Refresh token missing in response');
            }

            localStorage.setItem('jwt', access_token);
            if (response.data?.user) {
                localStorage.setItem('admin_user', JSON.stringify(response.data.user));
            }
            return access_token;
        } catch (e) {
            this.handleAuthFailure();
            throw e;
        }
    },

    async retryAuthRequest(requestFn) {
        try {
            return await requestFn();
        } catch (e) {
            if (e.response?.status !== 401) {
                throw e;
            }
            await this.refreshToken();
            return await requestFn();
        }
    },

    async getAuth(url, data = {}, headers = {}) {
        return this.retryAuthRequest(() =>
            axios.get(url, {
                data,
                headers: Object.assign(this.getAuthHeader(), headers),
            }),
        );
    },

    async postAuth(url, data = {}, headers = {}) {
        return this.retryAuthRequest(() =>
            axios.post(url, data, {
                headers: Object.assign(this.getAuthHeader(), headers),
            }),
        );
    },

    async get(url, data = {}, headers = {}) {
        return await axios.get(url, {data, headers});
    },

    getAuthHeader() {
        return {Authorization: `Bearer ${localStorage.getItem('jwt')}`};
    },

    async delete(url, data = {}, headers = {}) {
        return await axios.delete(url, {data, headers});
    },

    async deleteAuth(url, data = {}, headers = {}) {
        return this.retryAuthRequest(() =>
            axios.delete(url, {
                data,
                headers: Object.assign(this.getAuthHeader(), headers),
            }),
        );
    },
}
